import React, { useEffect, useMemo, useState } from "react";
import { Megaphone, Lock } from "lucide-react";
import { api } from "@/lib/api";
import { MaterialCard } from "@/components/marketing/MaterialCard";
import { EmailPrefs } from "@/components/marketing/EmailPrefs";

const FILTERS = [
  { id: "all", label: "Tutti" },
  { id: "new", label: "Nuovi" },
  { id: "kit", label: "Kit" },
  { id: "tip", label: "Consigli" },
  { id: "promo", label: "Promo" },
];

export const MarketingMaterials = () => {
  const [data, setData] = useState(null);
  const [blocked, setBlocked] = useState(null);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/agent/marketing").then((r) => setData(r.data)).catch((e) => {
      setBlocked(e?.response?.data?.detail?.message || "Materiali non disponibili");
    });
  }, []);

  const items = useMemo(() => {
    if (!data) return [];
    if (filter === "all") return data.items;
    if (filter === "new") return data.items.filter((i) => i.is_new);
    return data.items.filter((i) => i.kind === filter);
  }, [data, filter]);

  const markSeen = (item) => {
    if (!item.is_new) return;
    api.post(`/agent/marketing/${item.id}/seen`).catch(() => {});
    setData((d) => ({
      ...d,
      new_count: Math.max(0, d.new_count - 1),
      items: d.items.map((i) => (i.id === item.id ? { ...i, is_new: false } : i)),
    }));
  };

  if (blocked) {
    return (
      <div className="vg-card p-6 flex items-start gap-3" data-testid="marketing-blocked">
        <Lock size={18} className="text-gray-400 mt-0.5" />
        <div><h3 className="font-bold text-[#0A0A0A]">Materiali marketing</h3><p className="text-sm text-gray-500">{blocked}</p></div>
      </div>
    );
  }
  if (!data) return <div className="text-gray-400" data-testid="marketing-loading">Caricamento materiali…</div>;

  return (
    <section className="space-y-5" data-testid="marketing-materials">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="flex items-center gap-2 text-[#B40101]"><Megaphone size={18} /><h2 className="text-lg font-bold text-[#0A0A0A]">Materiali marketing</h2></div>
          <p className="text-sm text-gray-500">Testi, immagini e video pronti: il tuo link personale è già inserito. Archivio degli ultimi 6 mesi.</p>
        </div>
        {data.new_count > 0 && <span className="text-xs font-bold px-3 py-1 rounded-full bg-[#B40101] text-white" data-testid="marketing-new-count">{data.new_count} nuovi</span>}
      </div>
      <div className="flex gap-2 flex-wrap">
        {FILTERS.map((f) => (
          <button key={f.id} onClick={() => setFilter(f.id)} data-testid={`marketing-filter-${f.id}`}
            className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-colors ${filter === f.id ? "bg-[#404040] text-white" : "bg-white text-gray-600 border border-gray-200 hover:border-gray-400"}`}>
            {f.label}
          </button>
        ))}
      </div>
      <div className="grid lg:grid-cols-[1fr_280px] gap-5 items-start">
        <div className="space-y-3" data-testid="marketing-list">
          {items.length === 0 && <div className="vg-card p-6 text-sm text-gray-500" data-testid="marketing-empty">Nessun materiale disponibile in questa sezione.</div>}
          {items.map((i) => <MaterialCard key={i.id} item={i} assetBase="/agent/marketing/assets" onOpen={markSeen} />)}
        </div>
        <EmailPrefs prefs={data.prefs} onChange={(prefs) => setData((d) => ({ ...d, prefs }))} />
      </div>
    </section>
  );
};
